import TablaConciliacion from "../../../TablaConciliacion";

function TablaViaRioPamplonita() {
  return <TablaConciliacion nombreUseCase="VIARIOPAMPLONITA" titulo="VIA RIO PAMPLONITA" />;
}

export default TablaViaRioPamplonita;
